<template>
  <v-btn color="green" outlined @click="onExport">Xuất excel</v-btn>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/plugins/utils'
import { get } from 'lodash'

const getHeaderExcel = (questionHeaders = []) => {
  const headerExcel = [
    { text: 'Tên học sinh', value: 'name' },
    { text: 'Mã số', value: 'code' },
    { text: 'Trả lời lúc', value: 'createdAt' }
  ]
  headerExcel.splice(2, 0, ...questionHeaders)
  return headerExcel
}

const getAnswer = (item = {}, questionId = '', questionType = '') => {
  const answers = get(item, 'answers', [])
  if (Array.isArray(answers) && answers.length) {
    const answer = answers.find(a => a.question === questionId)
    if (questionType === 'text') return get(answer, 'answer', '--')
    return get(answer, 'answer.title', '--')
  }
  return '--'
}

export default {
  computed: {
    ...mapState({
      questions: state => state.surveyQuestion.items,
      survey: state => state.survey.item
    }),
    questionHeaders() {
      return this.questions.map((q, i) => ({ text: `Câu hỏi ${i + 1}: ${q.title}`, value: q.id, type: q.type }))
    }
  },
  methods: {
    ...mapActions({
      fetchAll: 'studentSurvey/fetchAll'
    }),
    async onExport() {
      try {
        this.$loading.active = true
        const rawList = await this.fetchAll()

        if (Array.isArray(rawList) && rawList.length) {
          const data = rawList.map(item => {
            const res = {
              name: get(item, 'student.name', ''),
              code: get(item, 'student.code_short', ''),
              createdAt: this.$options.filters.ddmmyyyyhhmm(get(item, 'createdAt', ''))
            }
            if (Array.isArray(this.questionHeaders) && this.questionHeaders.length) {
              this.questionHeaders.forEach(question => {
                res[question.value] = getAnswer(item, question.value, question.type)
              })
            }
            return res
          })
          utils.exportExcel(
            data,
            getHeaderExcel(this.questionHeaders),
            `Danh sách HS trả lời KS "${this.survey.title}"`
          )
        }
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
